import React, { PureComponent } from 'react';

import { Labeled } from 'components/ClubComponents';
import { Configuration } from 'components/configuration';
import { Dropzone } from 'components/dropzone';
import { I18n, translate } from 'components/translate';
import ClubDate from 'helpers/ClubDate';
import { CommunityService } from 'modules/community';
import ConfigurationService from 'modules/community/configuration/ConfigurationService';
import PropTypes from 'prop-types';

import './AutomatedCommentReplyConfiguration.scss';

@translate()
class AutomatedCommentReplyConfiguration extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      importDate: null
    };

    const { t } = props;

    this.toggleLabels = {
      on: t('general.yes'),
      off: t('general.no')
    };
  }

  async componentDidMount() {
    this.fetchImportDate();
  }

  async fetchImportDate() {
    const importDate = await CommunityService.getImportedDateLast();

    this.setState({ importDate });
  }

  renderInstructions() {
    const { importDate } = this.state;

    return (
      <React.Fragment>
        <p className="_mt-0 _mb-3 _text-4 _text-xl-2">
          <I18n label="community.configuration.import_date" />
          {`: ${ClubDate.format(importDate)}`}
        </p>
        <p className="_mt-0 _mb-5 _text-gray-400">
          <I18n label="community.configuration.save_comments_at_database" />
        </p>
        <div className="_text-gray-400">
          <div className="_line-height-lg">
            <I18n label="community.configuration.example_title" />
          </div>
          <dl className="automated-reply-configuration__sample__tsv  _p-0 _ml-0 _mt-0 _mr-0 _mb-5">
            <dt>{'Love'}</dt>
            <dd>
              <I18n label="community.configuration.first_example" />
            </dd>
            <dt>{'Love'}</dt>
            <dd>
              <I18n label="community.configuration.second_example" />
            </dd>
            <dt>{'Love'}</dt>
            <dd>
              <I18n label="community.configuration.third_example" />
            </dd>
          </dl>
        </div>
      </React.Fragment>
    );
  }

  renderUpload() {
    return (
      <React.Fragment>
        <Labeled
          className="tw-text-secondary-700"
          label={<I18n label="users_import.batch.file.label" />}
        >
          <Dropzone
            className="_mt-2"
            onDrop={ConfigurationService.onFilesChange}
            multiple={false}
            accept=".tsv, text/tab-separated-values, application/vnd.ms-excel"
          >
            <div className="_d-flex _flex-column tw-p-3">
              <p className="_m-0 tw-text-secondary-700 _tw-text-sm">
                <I18n label="community.configuration.upload_dropzone_label" />
              </p>
              <div className="_mt-3 _mt-md-5">
                <button className="hot-button hot-button--secondary hot-button--lg">
                  <I18n label="community.configuration.upload_button_label" />
                </button>
              </div>
            </div>
          </Dropzone>
        </Labeled>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Configuration
        className="automated-reply-configuration"
        title={<I18n label="community.configuration.upload_title" />}
      >
        <Configuration.Item>
          {this.renderInstructions()}
          {this.renderUpload()}

          <button
            className="hot-button hot-button--secondary hot-button--lg _mt-5"
            onClick={ConfigurationService.onExportFile}
          >
            <I18n label="community.configuration.export_tsv_label" />
          </button>
        </Configuration.Item>
      </Configuration>
    );
  }
}

AutomatedCommentReplyConfiguration.propTypes = {
  t: PropTypes.func
};

export default AutomatedCommentReplyConfiguration;
